import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { WorksheetRootComponent } from 'Components/Worksheets/Core/types';
import ids from 'Components/Worksheets/QestIds';
import { ResultsSection, WashingSection } from './Sections/SievingWash';

const qestIds = [ids.wash.BS_EN_ISO_17892_4_Clause_5_2.Rev2016];

let MeasuredWashSievingBsEnIsoWorksheet: WorksheetRootComponent = () => (
  <>
    <WashingSection />
    <ResultsSection />
  </>
);

MeasuredWashSievingBsEnIsoWorksheet.qestIds = qestIds;
MeasuredWashSievingBsEnIsoWorksheet = withInjectedProps(MeasuredWashSievingBsEnIsoWorksheet);

export default MeasuredWashSievingBsEnIsoWorksheet;
export { MeasuredWashSievingBsEnIsoWorksheet };
